"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const IsAllowed_1 = __importDefault(require("../../Auth/IsAllowed"));
const DetailPicturesCellRenderer = ({ data, node, api, plantIdColumn = 'id' }) => {
    const plantId = data[plantIdColumn];
    const picturesApi = new api_1.PicturesApi();
    const [pictures, setPictures] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const loadImages = async () => {
            setLoading(true);
            try {
                const { pictures } = await picturesApi.index({ modelId: plantId });
                setPictures(pictures);
            }
            catch (error) {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setLoading(false);
        };
        loadImages();
    }, []);
    const handleFloramediaChange = (picture) => (async (event) => {
        setLoading(true);
        try {
            await picturesApi.update(picture.id, { floramedia: event.target.checked });
            const { pictures } = await picturesApi.index({ modelId: plantId });
            setPictures(pictures);
        }
        catch (error) {
            (0, errorNotification_1.notifyError)(error);
        }
        setLoading(false);
    });
    return (react_1.default.createElement("div", { className: 'overflow-y-auto h-full p-4 bg-gray-100' }, pictures.length > 0 ? (react_1.default.createElement("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5" }, pictures.map((image) => (react_1.default.createElement("div", { key: image.name, className: "bg-white overflow-hidden shadow rounded-lg" },
        react_1.default.createElement("div", { className: "px-2 py-2" },
            react_1.default.createElement("div", { className: "h-48 overflow-hidden mb-2" },
                react_1.default.createElement("img", { className: "object-contain h-full w-full", src: image.thumbUrl + '?' + image.updated_at })),
            react_1.default.createElement("div", { className: "mb-1 text-gray-900 text-xs" },
                react_1.default.createElement("span", { className: 'break-all whitespace-normal' }, image.name)),
            react_1.default.createElement(IsAllowed_1.default, { permissions: ['upload_images'] },
                react_1.default.createElement("div", { className: "text-gray-900 text-xs text-center" },
                    react_1.default.createElement("label", { className: "text-gray-900 text-xs flex items-center cursor-pointer" },
                        react_1.default.createElement("input", { name: "selectedView", type: "checkbox", checked: (image.floramedia), onClick: handleFloramediaChange(image), readOnly: true, className: "mr-2 cursor-pointer checkboxx" }),
                        "Floramedia"))))))))) : (react_1.default.createElement("div", { className: "flex justify-center items-center" },
        react_1.default.createElement("span", { className: "text-gray-500 text-xl" }, loading ? 'Wird geladen...' : 'Keine Bilder')))));
};
exports.default = DetailPicturesCellRenderer;
